import React from 'react';
import { Block } from '../block';
import { BlockList } from '../block-list';
import { TitleDivider } from '../title-divider';

export class NewsList extends React.Component {
  constructor (props) {
    super(props);
    this.state = {};
  }

  imageForItem (item) {
    var header = item.modules?.find(_ => _.type === 'modulePageHeader');
    if (header && header.images?.length > 0) {
      return header.images[0].image?.file?.url;
    }
    return false;
  }

  render () {
    return (
      <section className="news-list">
        { this.props.eyebrow && <TitleDivider>{ this.props.eyebrow }</TitleDivider> }
        <BlockList wrap>
          { this.props.news && this.props.news.map(item => <Block {...item} image={this.imageForItem(item)} />) }
        </BlockList>
      </section>
    );
  }
}
